<template>
  <div>
    <b-form-group>
      <b-button
        :disabled="disabled"
        variant="outline-secondary"
        @click="showModal = true">
        <i class="fas fa-plus"></i>
        Add Members
      </b-button>
      <br>
      {{ taggedMembers.length }} tagged
      <br>
    </b-form-group>

    <b-modal
      v-model="showModal"
      title="Members"
      centered hide-footer
      size="lg">
      <members-table
        v-if="showModal"
        :view="view"
        :ids-to-highlight="taggedMembers"
        context="select"
        @removeAll="removeAll"
        @selectMember="addMemberRelation"/>
      <b-button
        variant="outline-primary"
        class="mt-3"
        block
        @click="showModal = false">
        Done Selecting
      </b-button>
    </b-modal>

  </div>
</template>

<script>
import { mapState } from 'vuex'
import membersTable from './table'

export default {
  components: {
    membersTable
  },
  props: {
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    initialMembers: {
      type: Array,
      required: true
    },
    namespace: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      showModal: false,
      taggedMembers: []
    }
  },
  computed: {
    ...mapState('groups', {
      view: '_defaultView'
    }),
    members () {
      return this.$store.getters['members/view'](this.view)
    }
  },
  mounted () {
    this.taggedMembers = this.initialMembers
    this.updateStore()
  },
  methods: {
    updateStore () {
      this.$store.commit(`${this.namespace}/forms/relateMembers/setField`, {
        field: 'memberIDs',
        value: this.taggedMembers
      })
    },
    removeAll () {
      this.taggedMembers = []
      this.updateStore()
    },
    addMemberRelation (member) {
      // toggle inclusion of members
      let idx
      let exists = false
      for (let i=0; i<this.taggedMembers.length; i++) {
        if (this.taggedMembers[i] === member.id) {
          exists = true
          idx = i
        }
      }

      if (exists) {
        this.taggedMembers.splice(idx, 1)
      } else {
        this.taggedMembers.push(member.id)
      }

      this.updateStore()
    },
    reset (event) {
      this.taggedMembers = this.initialMembers
      this.$store.commit(`${this.namespace}/forms/relateMembers/resetState`)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/admin/members/relateMembers.vue